var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.handleResize,
          expression: "handleResize",
        },
      ],
      staticClass: "bar-chart",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.setSelected($event)
        },
      },
    },
    [
      _vm.isShowEmpty
        ? [_vm._m(0)]
        : [
            !_vm.myOption.isNoData
              ? _c("scEcharts", {
                  ref: "scEchartsRefs",
                  staticClass: "chart",
                  attrs: { option: _vm.myOption, field: _vm.field },
                })
              : _c("div", { staticClass: "no-data" }, [
                  _vm._v("\n      请通过右侧\n      "),
                  _c("span", { staticClass: "lh" }, [_vm._v("维度指标设置")]),
                  _vm._v(" 维度、指标栏来添加数据\n    "),
                ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-div" }, [
      _c("span", [_vm._v("暂无数据")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }